import { GET } from '@/request/index'
/**
 * 获取数据
 * @param { 无 }
 * */
export const getData = (data) => {
  return GET(`/api/cms/content/list`, { data });
};